import { IMAGES, CLINIC } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export default function About() {
  const { t } = useLang();
  const a = t.about;

  return (
    <section id="about" data-testid="about-section" className="relative bg-brand-bg py-20 md:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-[2rem] spotlight shadow-2xl shadow-brand-ink/10">
            <img
              src={IMAGES.doctorSeated}
              alt="Dr. Vinita Jain consulting at Kesari Dental Clinic in Sector 16-17, Hisar"
              className="h-[440px] w-full object-cover md:h-[560px]"
              loading="lazy"
            />
          </div>
          <div className="absolute -right-3 -top-3 hidden rounded-2xl border border-brand-border bg-brand-surface px-5 py-4 shadow-xl md:block">
            <p className="font-display text-2xl text-brand-primary">{CLINIC.doctor}</p>
            <p className="text-xs font-medium uppercase tracking-widest text-brand-inksoft">
              {a.docCred}
            </p>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <Eyebrow>{a.eyebrow}</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-normal leading-tight tracking-tight text-brand-ink md:text-5xl">
              {a.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-brand-inksoft md:text-lg">
              <p>{a.p1}</p>
              <p>{a.p2}</p>
              {a.p3 && <p>{a.p3}</p>}
              <p className="font-display text-xl italic text-brand-primary">“{a.quote}”</p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 grid grid-cols-3 gap-4">
              {a.stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-brand-border bg-brand-surface p-4 text-center md:p-5">
                  <p className="font-display text-2xl text-brand-primary md:text-3xl">{s.value}</p>
                  <p className="mt-1 text-[11px] font-medium uppercase tracking-wider text-brand-inksoft">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
